import { AllocationBase } from "../../accounting/abstract/allocation-base.model";

export class CashTransactionAllocation extends AllocationBase {

    static override CLASS_NAME: string = 'CashTransactionAllocation';

}
